import React, {Component} from "react";
import {NavLink} from "react-router-dom";
import classes from './MenuItem.module.css';
import {Icon} from "@material-ui/core";
import * as actions from "../../../../store/actions";
import {connect} from "react-redux";

class MenuItem extends Component {
	render() {
		return (
			<li className={classes.MenuItem}>
				<NavLink
					to={this.props.link}
					exact={this.props.exact}
					onClick={() => this.props.toggleSideNav(false)}
					activeClassName={classes.active}>
					<span className={classes.MenuIcon}>
						<Icon style={{ fontSize: 30 }}>{this.props.icon}</Icon>
					</span>
					<span className={classes.MenuText}>{this.props.text}</span>
				</NavLink>
			</li>
		)
	}
}

const mapDispatchToProps = dispatch => {
	return {
		toggleSideNav: (showSideNav) => dispatch( actions.toggleSideNav(showSideNav) )
	}
};

export default connect(null, mapDispatchToProps)(MenuItem);
